import { HealthcareFacilityLocationSimple } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import {
   addressFormatter,
   createTranslatedText,
   useInterpolatedTranslationKey,
   useTranslate,
} from '@dreryk/react-common';
import { AutoLayout, EditIcon, Tree } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';
import { HealthcareBasicData } from '../../../common/HealthcareBasicData';
import { StyledHealthcareTreeItemText } from '../StyledHealthcareTreeItemText';

import { HealthcareFacilityLocationUpdateLink } from './HealthcareFacilityLocationUpdateLink';

type HealthcareFacilityLocationTreeLeafProps = {
   readonly healthcareFacilityLocation: HealthcareFacilityLocationSimple;
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
};

export const HealthcareFacilityLocationTreeLeaf = (props: HealthcareFacilityLocationTreeLeafProps): JSX.Element => {
   const translate = useTranslate();
   const locationCode = useInterpolatedTranslationKey(healthcareOrganizationTranslationKeys.locationCode, {
      locationCode: props.healthcareFacilityLocation.locationCode,
   });
   const address = addressFormatter(props.healthcareFacilityLocation.address);

   return (
      <Tree.Leaf
         testId={`healthcareFacilityLocation-${props.healthcareFacilityLocation.id}`}
         content={
            <AutoLayout
               as={'div'}
               $horizontalResizing={'fill'}
               $spacingMode={'space-between'}
               $spacing={4}
               $alignement={'center'}
            >
               <AutoLayout as={'div'} $direction={'vertical'} $spacing={4}>
                  <StyledHealthcareTreeItemText testId={'locationCode'}>
                     {translate(locationCode)}
                  </StyledHealthcareTreeItemText>
                  <HealthcareFacilityLocationUpdateLink
                     testId={'name'}
                     label={createTranslatedText(props.healthcareFacilityLocation.name)}
                     healthcareFacilityLocationId={props.healthcareFacilityLocation.id}
                     healthcareParentData={props.healthcareParentData}
                     onDataChanged={props.onDataChanged}
                  />
                  {address ? (
                     <StyledHealthcareTreeItemText testId={'address'}>{address}</StyledHealthcareTreeItemText>
                  ) : null}
               </AutoLayout>

               <HealthcareFacilityLocationUpdateLink
                  testId={'healthcareFacilityLocationUpdate'}
                  icon={<EditIcon />}
                  healthcareFacilityLocationId={props.healthcareFacilityLocation.id}
                  healthcareParentData={props.healthcareParentData}
                  onDataChanged={props.onDataChanged}
               />
            </AutoLayout>
         }
      />
   );
};
